// Navbar.jsx
import React from 'react';
import { useAuth } from '../../contexts/AuthProvider'; // Importa il hook
import useUtente from '../../hooks/useUtente';


function Navbar() {
    const utente = useUtente();
    const { logout } = useAuth(); // Estrai la funzione logout dal contesto

    const handleLogout = (e) => {
        e.preventDefault(); // Previeni il comportamento di default del link
        logout(); // Esegui la funzione di logout
    };

    return (

        
        <div className="navbar navbar-dark navbar-expand-lg navbar-static border-bottom border-bottom-white border-opacity-10">
            <div className="container-fluid">
                <div className="d-flex d-lg-none me-2">
				<button type="button" className="navbar-toggler sidebar-mobile-main-toggle rounded">
					<i className="ph-list"></i>
				</button>
			</div>
            <div className="navbar-brand">
				<div className="d-inline-flex align-items-center">
					<img src="" alt="" />
				</div>
			</div>
            <div className="d-lg-none ms-2">
				<button className="navbar-toggler collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#navbar-mobile" aria-expanded="false">
					<i className="ph-squares-four"></i>
				</button>
			</div>
            <div className="navbar-collapse order-2 order-lg-1 collapse" id="navbar-mobile" >
				
			</div>
            <ul className="nav gap-sm-2 order-1 order-lg-2 ms-auto">
				
				<li className="nav-item nav-item-dropdown-lg dropdown">
					<a href="#" className="navbar-nav-link align-items-center rounded p-1" data-bs-toggle="dropdown" aria-expanded="false">
						<div className="status-indicator-container">
							<img src="../../../public/tabata/images/icon.png" className="w-32px h-32px rounded" alt="" />
							<span className="status-indicator bg-success"></span>
						</div>
						<span className="d-none d-lg-inline-block mx-lg-2"><p>Benvenuto: {utente?.nome} {utente?.cognome}</p></span>
					</a>

					<div className="dropdown-menu dropdown-menu-end">
						<a href="#" className="dropdown-item"  onClick={handleLogout}>LOGOUT</a>
					</div>
				</li>
			</ul>
            


               
            </div>
        </div>
    );
}

export default Navbar;
